import { render, staticRenderFns } from "./FrzPackingCreateBins.vue?vue&type=template&id=719a8de4"
import script from "./FrzPackingCreateBins.vue?vue&type=script&lang=js"
export * from "./FrzPackingCreateBins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports